import { useMemo } from 'react';
import { formatMessageWithLocale } from '../../../locales';
import '../Admonition.less';
import type { admonitionTag } from '../plugins/remark-directive-extension-lib/remark-admonition';
import { AdmonitionConfig } from './AdmonitionConfig';
import type { MdComponentIndexProps } from './type';

export function Admonition(
  props: React.PropsWithChildren<
    {
      tagName: (typeof admonitionTag)[number];
      customName: string;
      customTitle?: string | null | React.ReactNode;
      locale: string;
      customIcon?: React.ReactNode;
    } & MdComponentIndexProps
  >,
) {
  const icon = props.customIcon ?? AdmonitionConfig[props.tagName]?.icon;
  const hiddenTitle = props.customTitle === '';
  const title = useMemo(() => {
    return (
      props.customTitle ||
      props.customName ||
      formatMessageWithLocale(props.locale, { id: props.tagName })
    );
  }, [props.tagName, props.customTitle, props.locale]);
  return hiddenTitle ? (
    <div
      className={'markdown-child-root flex admonition admonition-' + props.tagName}
      data-markdown-component="x-admonition"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div
        className={'flex-0 admonition-title admonition-title-' + props.tagName}
        style={{
          lineHeight: '24px',
          width: '24px',
          height: '24px',
          // display: "flex",
          // alignSelf: "center",
          // justifyContent: "center"
        }}
      >
        {icon}
      </div>
      <div className="markdown-child-root flex-1">{props.children}</div>
    </div>
  ) : (
    <div
      className={'markdown-child-root admonition admonition-' + props.tagName}
      data-markdown-component="x-admonition"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div
        className={'admonition-title admonition-title-' + props.tagName}
        style={{
          marginBottom: '4px',
        }}
      >
        {icon}
        {title}
      </div>
      <div className="pl-6 markdown-child-root">{props.children}</div>
    </div>
  );
}
